<template>
  <div class="gerar-novo-pedido-orcamento">
    <g-card 
    :paddingDefault="'0px'"
    minAltura="0px"
    class="card-form-selecione-orcamento">
        <template #cabecalho>
          <div class="header-selecione-orcamento">
            <div class="titulo-fluxos"> Selecione um Orçamento </div>
          </div>
        </template>
      </g-card>
    
    <g-card
      class="Card-Principal"
      :expansivel="false" 
      :temCabecalho="false"
      :paddingDefault="'0 0 4em'"
    >
      <g-data-table
        TextoVazio="Nenhum Orçamento"
        :colunas="colunasTabelastep1"
        :valores="OrcamentoArray"
        :NumeroLinhas="100"
        :Editavel="false"
        :esconderColunaFrozen="true"
        :Filtros="Filtro"
        :temColunaSelecaoUnica="true"
        :campoAgrupador="'empresaCliente'"
        :campoExibicaoGrupo="'empresaCliente'"
        :colunaColorida="'statusEnumTexto'"
        :GetStatusColors="'corStatus'"
        :GetVencimentoColors="'corStatus2'"
        ref="tabela"
        
      >
        <template #titulo>
          <div class="titulo">
            <g-button
            class="botao_selecione_orcamento"
            largura="auto"
            icone="icone_voltar.svg"
            negritoTexto
            altura="30px"
            cor="#f8f9fa"
            corTexto="#4f4c4d"
            fontTexto="MontSerrat"
            tamanhoIcone="10px"
            tamanhoTexto="20px"
            :sombreado="false"
            @click="VoltarInicio()"
            >
              Selecione um Orçamento
            </g-button>
          </div>
        </template> 
      </g-data-table>

      <div class="popup-quantidade-tipo-pedido">
        <PDialog id="popup-quantidade-tipo-pedido" 
        :breakpoints="{'1200px': '50%', '800px': '70%', '400px': '90%'}"
        :showHeader="false" 
        :closable="false" 
        :modal="true"
        v-model:visible="popup" 
        >
          <div class="conteudo-popup-quantidade-tipo-pedido">
            <div class="pedido-situacao-container" v-if="this.opcoesRepeticao">
              <div class="titulo-conteudo-fluxos"> Pedido deverá ser  </div>
              <div class="pedido-situacao-box">
                <div class="pedido-repeticao-ra-container">
                  <PRadioButton
                    :binary="true"
                    class="radio"
                    :value="1"
                    name="btnRepeticao"
                    v-model="novoPedidoViewModel.PedidoSituacao"
                  ></PRadioButton>
                  <label class="opcoes-pedido-situacao">Repetição (sem nenhuma alteração)</label>
                </div>
                <div class="pedido-repeticao-ra-container">
                  <PRadioButton
                    :binary="true"
                    class="radio"
                    :value="2"
                    name="btnRA"
  
                    v-model="novoPedidoViewModel.PedidoSituacao"
                  ></PRadioButton>
                  <label class="opcoes-pedido-situacao">Repetição com alteração (não influencia no custo)</label>
                </div>
              </div>
            </div>
            <div class="tipo-pedido">
              <div class="titulo-conteudo-fluxos"> Tipo do Pedido </div>
              <PDropDown
              class="tipo-pedido-input input-label"
              placeholder="Selecione"
              v-model="novoPedidoViewModel.TipoPedido"
              :disabled="!bloquearEscolha"
              :options="dataOption"
              optionLabel="name"
              optionValue="value"   
              :class="{'select':true, 'p-invalid': submit, 'markup-relacao-dropdown': true}"
              >
              
                <template #option="slotProps">
                <div :style="{color:  slotProps.option.color}">{{ slotProps.option.name }}</div> 
                </template>
              </PDropDown>
                
            </div>

            <div class="quantidade">
              <div class="titulo-conteudo-fluxos"> Quantidade </div>
              <PDropDown
              class="quantidade-input input-label"
              placeholder="Selecione"
              v-model="novoPedidoViewModel.MarkupRelacaoId"
              :options="arrayQuantidade"
              optionLabel="text"
              optionValue="markupRelacaoId"                
              @change="verificaPedido"
              :class="{'select':true, 'p-invalid': submit, 'markup-relacao-dropdown': true}"
              >
              </PDropDown>
            </div>
           
          </div>

          <div class="botoes-popup">
            <div>
              <g-button
              tipo="cinza"
              negritoTexto 
              largura="200px" 
              altura="35px"
              @click="fecharDialog"
              >
              VOLTAR            
              </g-button>
            </div>
            <div>
              <g-button
              tipo="amarelo"
              negritoTexto
              largura="200px" 
              altura="35px"
              @click="infoCliente"
              >
                CONTINUAR
              </g-button>
            </div>
          </div>
        </PDialog>
      </div>

      <div class="buttons-next-back">
        <div class="button-next">
          <g-button
            tipo="amarelo"
            altura="35px"
            largura="100%"
            negritoTexto 
            @click="abrirSelecaoQuantidade"
            >
              CONTINUAR
            </g-button>
        </div>
        <div class="button-back">
          <g-button
          tipo="cinza" 
          altura="35px"
          largura="100%"
          negritoTexto 
          @click="VoltarInicio()"
          >
            VOLTAR
          </g-button>
        </div>
      </div>

      <div class="primeiro-pedido">
      <PDialog :showHeader=true :closable="false" header="Cliente em Desenvolvimento(DA), atualize-o para continuar" v-model:visible="popupPrimeiroPedido" :modal="true" >
        <div class="conteudo-popup-edicao"> </div>
        <div class="editar-informacoes-cliente">
          <div class="botoes">
            <div class="botaoContinuar">
              <g-button tipo="amarelo" largura="100px" negritoTexto @click="alteraClienteSituacao"> ALTERAR SITUACAO </g-button>
            </div>
            
            <div class="botaoVoltar">
              <g-button tipo="cinza" largura="100px" negritoTexto @click="popupPrimeiroPedido = false"> CANCELAR </g-button>
            </div>
          </div>
        </div>
      </PDialog>
    </div>

      <div class="mais-de-meio-ano">
      <PDialog :showHeader=true :closable="false" header=" Cliente não compra a mais de um ano e meio, confira os dados desse cliente e atualize se for necessário. " v-model:visible="popupClienteTempoDeCompra" :modal="true" >
        <div class="conteudo-popup-edicao"> </div>
        <div class="editar-informacoes-cliente">
          <div class="botoes">
            <div class="botaoContinuar">
              <g-button tipo="cinza" largura="100%" negritoTexto @click="redirecionaParaFicha"> ATUALIZAR DADOS </g-button>
            </div>

            <div class="botaoVoltar">
              <g-button tipo="amarelo" largura="100%" negritoTexto @click="this.popupClienteTempoDeCompra = false"> CONTINUAR PEDIDO</g-button>
            </div>

          </div>
        </div>
      </PDialog>
    </div>

    </g-card>
  </div>
</template>

<script>
import GerarNovoPedidoOrcamento from "./GerarNovoPedidoOrcamento.js";
export default GerarNovoPedidoOrcamento;
</script>

<style scoped>
.botoes {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 1fr;
  margin-top: 5%;
  grid-gap: 20px;
}

.botaoContinuar {
  grid-area: 1/2/2/3;
  justify-self: left;
  width: 40%;
}

.botaoVoltar {
  grid-area: 1/1/2/2;
  justify-self: end;
  width: 40%;
}

.selecione-orcamento-titulo {
    color: #4f2c19;
    font-weight: 600;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.conteudo-popup-quantidade-tipo-pedido { 
  display: flex;
  flex-direction: column;
  gap: 10px;  
  margin: 2em 1rem; 
}

.opcoes-pedido-situacao{
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  padding: 5px 0;
}

.titulo {
  color: #747474;
  text-align: left;
  font-family: Montserrat;
  font-weight: bold;
  padding: 5px 0;
}

.botoes-quantidade-tipo-pedido {
  display: flex;
  justify-content: space-between;
  gap: 20px;
  margin: 1rem;
}

.pedido-situacao-box{
  display: flex;
  flex-direction: column;
  column-gap: 0.5rem;
}

.pedido-repeticao-ra-container {
  display: flex;
  align-items: center;
  column-gap: 0.2rem;
}


@media (min-width: 310px) {
  :deep(.p-dropdown-items-wrapper .p-dropdown-items) {
    width: 100vw !important;
  }
  .selecione-orcamento-titulo {
    font-size: 18px;
    margin: 0;
}
  .card-form-selecione-orcamento{
    display: flex;
  }
  .botao_selecione_orcamento{
    display: none;
  }
  .botoes {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 10px;
    margin-top: 5%;
  }

  .botaoContinuar {
    grid-area: 1/1/2/2;
    justify-self: center;
    width: 90%;
  }

  .botaoVoltar {
    grid-area: 2/1/3/2;
    justify-self: center;
    width: 90%;
  }
}

@media (min-width: 368px) {
  .buttons-next-back {
    margin: 50px 20px 30px;
  }
}

@media (min-width:400px) {
  .buttons-next-back {
    margin: 50px 0 30px;
  }
}

@media (min-width: 600px) {
  .card-form-selecione-orcamento{
    display: none;
  }
  .botao_selecione_orcamento{
    display: flex;
    white-space: nowrap;
  }
  .botoes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    margin-top: 3%;
    grid-gap: 20px;
  }

  .botaoContinuar {
    grid-area: 1/2/2/3;
    justify-self: left;
    width: 50%;
  }

  .botaoVoltar {
    grid-area: 1/1/2/2;
    justify-self: end;
    width: 50%;
  }
}

@media (min-width: 801px) {
  .botaoContinuar {
    grid-area: 1/2/2/3;
    justify-self: left;
    width: 35%;
  }

  .botaoVoltar {
    grid-area: 1/1/2/2;
    justify-self: end;
    width: 35%;
  }
}

@media (min-width: 1025px) {
  .botoes {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: 1fr;
    margin-top: 3%;
    grid-gap: 40px;
  }

  :deep(.p-dropdown-items-wrapper .p-dropdown-items) {
    width: 560px !important;
  }
}

@media (min-width: 1281px) {
}
</style>
